// SPDX-License-Identifier: GPL-3.0-or-later

/** Shared, DOM-free cache names and request markers for parent-owned range persistence. */

/** Sole persistent owner of verified range payloads, keyed by their real URLs. */
export const MULTIKEY_RANGE_CACHE = "sb-multikey-ranges-v2";
/** Small inventories and durable URL ownership markers; contains no PDF payloads. */
export const MULTIKEY_SOURCE_META_CACHE = "sb-multikey-source-meta-v2";
/** Marks app-managed downloads so the service worker never makes a runtime copy. */
export const MULTIKEY_RANGE_REQUEST_HEADER = "X-SB-Multikey-Range";
/** Previous hash-scoped source storage, retired lazily after verified adoption/replacement. */
export const MULTIKEY_LEGACY_SOURCE_PREFIX = "sb-multikey-source-v1-";

/** Returns a synthetic metadata key that cannot shadow the actual range response. */
export function multikeyRangeMarkerUrl(url: string): string {
  const marker = new URL("/__sb-multikey-cache/range", url);
  marker.searchParams.set("url", url);
  return marker.href;
}
